import { create } from "zustand";
import { persist } from "zustand/middleware";
import { api } from "@/shared/lib/api";

interface Admin {
  id: string;
  email: string;
  name: string;
}

interface AdminState {
  admin: Admin | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;

  // Actions
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  clearError: () => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      admin: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      login: async (email: string, password: string) => {
        set({ isLoading: true, error: null });
        try {
          api.setTokenContext("admin");
          const response = await api.adminLogin(email, password);
          api.setToken(response.token, "admin");
          set({
            admin: response.admin as Admin,
            isAuthenticated: true,
            isLoading: false,
          });
        } catch (err) {
          const error = err as Error;
          set({
            error: error.message || "Błąd logowania",
            isLoading: false,
          });
          throw err;
        }
      },

      logout: () => {
        api.setToken(null, "admin");
        set({
          admin: null,
          isAuthenticated: false,
          error: null,
        });
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: "admin-storage",
      partialize: (state) => ({
        admin: state.admin,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        if (state?.isAuthenticated) {
          api.setTokenContext("admin");
          const token = localStorage.getItem("advisor_panel_admin_token");
          if (token) {
            api.setToken(token, "admin");
          } else {
            state.admin = null;
            state.isAuthenticated = false;
          }
        }
      },
    }
  )
);
